<template>
  <section class="qrs-typography">
    <pageHeader class="mb--0" v-if="isapp">
      <h2 class="qrs-header-xl mt--0 mb--0">Medicines sick day guidance</h2>
    </pageHeader>
    <h1 v-if="!isapp" class="qrs-header-xl">Medicines sick day guidance</h1>
    <a
      @click="goBack()"
      class="govuk-back-link"
      role="button"
      aria-label="go back to the previous screen"
    >
      <strong>Previous</strong>
    </a>

    <h3>Summary</h3>
    <p>To save an electronic version of your Medicines Sick Day Guidance Card, use the “Share” button below to email the card to yourself. You can then download and save it.</p>
    <p class="mb--24">You can also email your Medicines Sick Day Guidance Card to people who can help you stay well. For example - a family member, a carer, a healthcare professional. You will need to know their email address.</p>
    
    <div v-for="(item, index) in answeredItems[0]" v-bind:key="index">
      <p v-if="item.id != 'Other medicines'" class="firstLetter">
        {{ item.id }}
      </p>
      <p v-else>
        <strong>{{ item.id }}</strong>
      </p>
      <div v-for="innerItem in item.data" v-bind:key="innerItem.id">
        <ul>
          <li v-if="innerItem.value.length > 0">{{ innerItem.value }}</li>
          <!-- <li v-else>{{item.response}}</li> -->
        </ul>
      </div>
      <div>
        <ul v-if="item.response.length > 0">
          <li>
            {{item.response}}
          </li>
        </ul>
      </div>
      <hr class="divider divider--dotted" />
    </div>

    <div class="mt--24">
      <button
        v-if="!isapp"
        name="Share via email"
        aria-label="Share my information via email"
        class="govuk-button mr--16"
        @click="$parent.goTo($Share)"
      >
        Share via email
        <span class="screen-reader-text">Share my information via email</span>
      </button>
      <button
        v-if="isapp"
        name="Share via email"
        aria-label="Share my information via email"
        class="govuk-button"
        @click="$parent.goTo($Share)"
      >
        Share via email
        <span class="screen-reader-text">Share my information via email</span>
      </button>
      <button
        v-if="!isapp"
        name="Print medicine sick day guidance card"
        aria-label="Print medicine sick day guidance card"
        class="govuk-button govuk-button--neutral mr--16"
        @click="printCard()"
      >
        Print this form
        <span class="screen-reader-text"
          >Print medicine sick day guidance card</span
        >
      </button>
      <button
        name="Cancel"
        aria-label="return to the previous page"
        class="govuk-button govuk-button--neutral"
        @click="cancelClicked()"
      >
        Cancel
        <span class="screen-reader-text">return to the previous page</span>
      </button>
    </div>
  </section>
</template>

<script>
import pdfhelper from "../../components/helpers/pdfHelper.js";

export default {
  name: "formSummary",

  data() {
    return {
      isapp: this.$parent.isapp,
      jsonData: this.$parent.jsonData,
      answeredItems: this.$parent.answeredItems,
    };
  },

  methods: {
    goBack() {
      this.answeredItems.length = 0;
      this.$parent.goTo(this.$GuidanceForm);
    },
    cancelClicked() {
      for (var i in this.jsonData) {
        this.jsonData[i].data.forEach(function (item) {
          item.value = "";
        });
      }
      this.answeredItems.length = 0;
      this.$parent.goTo(this.$Intro);
    },
    printCard() {
      var isnativeapp = document.getElementById("isnativeapp");
        if (isnativeapp === undefined || isnativeapp === null) {
          console.log("printing...");
          let pdfhtml = pdfhelper.generateHtmlforPdfWeb(this.answeredItems[0]);
          let mywindow = window.open(
            "",
            "PRINT",
            "width=device-width, height=device-height"
          );
          setTimeout(() => {
            mywindow.document.write(pdfhtml);
          }, 100);
          setTimeout(() => {
            mywindow.print();
            mywindow.close();
          }, 200);
        } else {
          console.log("app builds unsupported currently");
        }
    },
    // getMedicineTotal() {
    //   let medTotal = JSON.stringify(this.jsonData.total);
    //   console.log(isNaN(medTotal));
    //   for (var i in this.jsonData) {
    //     let catTotal = 0;
    //     this.jsonData[i].data.forEach(function (item) {
    //       if (item.value.length > 0) {
    //         catTotal++;
    //         console.log(catTotal);
    //       }
    //     });
    //     medTotal = catTotal;
    //     console.log(medTotal);
    //   }
    // },
  },
};
</script>